import { motion } from 'framer-motion';
import { UserPlus, Package, Bell, KeyRound } from 'lucide-react';

const steps = [
  {
    icon: UserPlus,
    title: 'Cadastre-se',
    description: 'Crie sua conta gratuitamente em menos de 2 minutos. Simples e rápido.',
    color: 'bg-lokker-blue',
  },
  {
    icon: Package,
    title: 'Receba no Locker',
    description: 'Suas encomendas são entregues diretamente no locker mais próximo de você.',
    color: 'bg-lokker-lime',
  },
  {
    icon: Bell,
    title: 'Seja Notificado',
    description: 'Receba uma notificação no celular assim que sua encomenda chegar.',
    color: 'bg-lokker-blue',
  },
  {
    icon: KeyRound,
    title: 'Retire Quando Quiser',
    description: 'Use o código exclusivo para abrir o locker no horário que preferir.',
    color: 'bg-lokker-lime',
  },
];

export const HowItWorks = () => {
  return (
    <section id="como-funciona" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="inline-block bg-lokker-lime/20 text-slate-700 text-sm font-medium px-4 py-2 rounded-sm mb-4">
            Como Funciona
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900 mb-4">
            Simples assim
          </h2>
          <p className="text-lg text-slate-600">
            Em apenas 4 passos, você recebe suas encomendas com total praticidade e segurança.
          </p>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`how-it-works-step-${index + 1}`}
              className="relative group"
            >
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-slate-200 z-0">
                  <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-lokker-lime rounded-full" />
                </div>
              )}

              <div className="relative bg-white border border-slate-200 p-8 rounded-sm card-hover z-10">
                {/* Step Number */}
                <div className="absolute -top-3 -right-3 w-8 h-8 bg-slate-900 text-white font-heading font-bold flex items-center justify-center rounded-sm text-sm">
                  {index + 1}
                </div>

                {/* Icon */}
                <div className={`w-16 h-16 ${step.color} rounded-sm flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <step.icon className={`w-8 h-8 ${step.color === 'bg-lokker-lime' ? 'text-black' : 'text-white'}`} />
                </div>

                {/* Content */}
                <h3 className="font-heading font-semibold text-xl text-slate-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center mt-16"
        >
          <p className="text-slate-600 mb-4">
            Pronto para começar?
          </p>
          <a
            href="/planos"
            data-testid="how-it-works-cta"
            className="inline-flex items-center gap-2 btn-primary px-8 py-4 rounded-sm"
          >
            Ver Planos Disponíveis
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
